<template>
  <div :class="$b()">
    <BaseAvatar
      v-if="content.athleteAvatar"
      :class="$b('avatar-large')"
      :image="content.athleteAvatar"
      size="large"
    />

    <div
      v-if="content.dateOfBirth"
      :class="$b('item')"
    >
      <div :class="$b('body', { 'has-no-avatar': !content.athleteAvatar })">
        <BaseCopy size="body-sm">
          Date of Birth:
        </BaseCopy>

        <BaseCopy size="h4">
          {{ $dayjs(content.dateOfBirth).format('Do MMMM YYYY') }}
        </BaseCopy>
      </div>
    </div>

    <BaseCopy
      v-if="metaGroupTitle"
      :class="$b('heading')"
      size="body"
    >
      {{ metaGroupTitle }}
    </BaseCopy>

    <div
      v-for="(item, index) in resolvedItems"
      :key="index"
      :class="$b('item')"
    >
      <BaseAvatar
        v-if="!isProTeamPage && item.person"
        :class="$b('avatar')"
        :image="item.person.avatar"
      />
      <div :class="$b('body', { 'has-no-avatar': !item.person })">
        <BaseCopy
          v-if="!metaGroupTitle && item.title"
          size="body-sm"
        >
          {{ item.title }}
        </BaseCopy>

        <BaseCopy size="h4">
          {{ copy(item) }}
        </BaseCopy>

        <div
          v-if="!isProTeamPage && item.person"
          :class="$b('social-container')"
        >
          <VisionIcon
            v-if="item.person.socialHandleType"
            :icon="item.person.socialHandleType"
            colour="black"
            size="x-small"
          />
          <BaseCopy size="body-sm">
            {{ item.person.socialHandle }}
          </BaseCopy>
        </div>
      </div>
    </div>

    <div
      v-if="isProTeamPage && content.socialHandle"
      :class="$b('social-pro-team')"
    >
      <BaseCopy size="body-sm">
        Social
      </BaseCopy>

      <div :class="$b('social-container')">
        <VisionIcon
          v-if="content.socialHandleType"
          :icon="content.socialHandleType"
          colour="black"
          size="x-small"
        />
        <BaseCopy size="h4">
          {{ content.socialHandle }}
        </BaseCopy>
      </div>
    </div>

    <ShareLinkGroup
      v-if="!isProTeamPage && content && content.items.length"
      :class="$b('share-link-group')"
    />

    <RelatedContent
      v-if="articles.length"
      :articles="articles"
      :class="$b('related-content')"
    />
  </div>
</template>

<script>
export default {
  name: 'ArticleMeta',

  props: {
    content: {
      type: Object,
      required: true,
    },

    isProTeamPage: {
      type: Boolean,
      default: false,
    },

    date: {
      type: String,
      default: '',
    },

    metaGroupTitle: {
      type: String,
      default: '',
    },

    articles: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    resolvedItems() {
      if (!this.content.items?.length && !this.isProTeamPage) {
        // If we don't have any items then create some dummy entries so it's not empty
        return [
          {
            title: 'Published',
            copy: this.$dayjs(this.date).format('Do MMMM YYYY'),
          },
        ]
      }

      return this.content.items
    },
  },

  methods: {
    copy(item) {
      if (!this.isProTeamPage && (item.person?.title || item.person?.name))
        return item.person?.title || item.person?.name
      return item.copy
    },
  },
}
</script>

<style lang="postcss">
.ArticleMeta__avatar-large {
  margin-bottom: 32px;
}

.ArticleMeta__heading {
  @apply mb-xs;
}

.ArticleMeta__item {
  @apply flex items-center;

  &:not(:last-of-type) {
    @apply mb-xs;

    @screen sm {
      margin-bottom: 20px;
    }
  }
}

.ArticleMeta__avatar {
  @apply mr-xs;
}

.ArticleMeta__body {
  @screen smMax {
    margin-top: 2px;
  }

  @screen sm {
    &--has-no-avatar {
      @apply space-y-2;
    }
  }
}

.ArticleMeta__title {
  margin-bottom: 2px;
}

.ArticleMeta__social-container {
  @apply flex items-center space-x-1;
}

.ArticleMeta__social-pro-team {
  @apply space-y-2;
}

.ArticleMeta__share-link-group {
  margin-top: 32px;
  left: calc(0px - theme('spacing.xxs'));
}

.ArticleMeta__related-content {
  @apply hidden md:block md:mt-md;
}
</style>
